module.exports = __webpack_public_path__ + "img/double.tick.e01a2f99.svg";